/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksFilters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AssignedTo from './AssignedTo/index'
import Board from './Board/index'
import DueDate from './DueDate/index'
import IsPastDueDate from './IsPastDueDate/index'
import Location from './Location/index'
import Patient from './Patient/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TasksFilters({
  children,
  viewPath = "/DesignSystem/TasksFilters",
  boardId
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="TasksFilters.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2vTHM4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Filter by:"
/>
<Location
  viewPath={`${viewPath}/Location`}
 boardId={boardId}
/>
<Board
  viewPath={`${viewPath}/Board`}
 boardId={boardId}
/>
<Stage
  viewPath={`${viewPath}/Stage`}
 boardId={boardId}
/>
<IsPastDueDate
  viewPath={`${viewPath}/IsPastDueDate`}
/>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
<AssignedTo
  viewPath={`${viewPath}/AssignedTo`}
/>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</div>
{children}
</React.Fragment>)
}